import React from "react";
import { Box } from "@mui/material";
import "./SubscriptionSwitch.scss";

const SubscriptionSwitch = (props:any) => {
  const {buttonTextLeft, buttonTextRight, badgeText,showSubscription, onToggle } = props

  // Handle click for toggling
  const handleClick = (isSubscription:boolean) => {
    if (onToggle) {
      onToggle(isSubscription);
    }
  };


  return (
    <Box className="subscriptionSwitch">
      {/* 1. THE GLIDER (The moving background) */}
      <Box
        className="glider"
        sx={{
          transform: showSubscription ? "translateX(100%)" : "translateX(0)",
        }}
      />

      {/* 2. OPTION: Single Time */}
      <Box
        className={`switchOptions ${!showSubscription ? "active" : ""}`}
        onClick={() => handleClick(false)}
      >
        {buttonTextLeft}
      </Box>

      {/* 3. OPTION: Subscription */}
      <Box
        className={`switchOptions ${showSubscription ? "active" : ""}`}
        onClick={() => handleClick(true)}
      >
        <span className="label">{buttonTextRight}</span>
        <span className="newBadge">{badgeText}</span>
      </Box>
    </Box>
  );
};

export default SubscriptionSwitch;